import { getStore } from 'Modules/store';
import { updateOnlineStatus } from './actions';
import ConnectionService from '../../../Services/ConnectionService';

export default function onlineStatus() {
  const store = getStore();
  const { dispatch } = store;
  const connectionService = new ConnectionService();

  connectionService.onConnectionStateChange((connectionState) => {
    dispatch(
      updateOnlineStatus(connectionState === ConnectionService.CONNECTION_SERVICE_STATE.ONLINE)
    );
  });
}
